module.exports = __webpack_public_path__ + "static/media/nextPage.5b959f19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nextPage.svg
// module id = 2443
// module chunks = 0